import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useAdminUserPageViewsQuery } from '../../api/admin';
import { formatDateTime } from '../../utils/dates';
import AdminQuickFilterToolbar from './AdminQuickFilterToolbar';

interface Props {
	userId: number;
	height?: number | string;
}

export default function UserPageViewsTable({ userId, height = 'calc(100vh - 310px)' }: Props) {
	const { data: pageViews, isLoading } = useAdminUserPageViewsQuery(userId);

	const columns: GridColDef[] = [
		{
			field: 'created_at',
			headerName: 'Date',
			width: 170,
			valueFormatter: ({ value }) => formatDateTime(value),
		},
		{
			field: 'page',
			headerName: 'Page',
			flex: 1,
			minWidth: 200,
		},
		{
			field: 'info',
			headerName: 'Info',
			flex: 1,
			minWidth: 150,
		},
	];

	return (
		<Box sx={{ height, minHeight: 300 }}>
			<DataGrid
				rows={pageViews ?? []}
				columns={columns}
				loading={isLoading}
				getRowId={(row) => `${row.created_at}-${row.page}`}
				disableSelectionOnClick
				components={{ Toolbar: AdminQuickFilterToolbar }}
				sortModel={[{ field: 'created_at', sort: 'desc' }]}
				density="compact"
			/>
		</Box>
	);
}
